module.exports = __webpack_public_path__ + "static/media/logo.b5dcc3d9.svg";